import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import { Loader, Checkbox, Search, useInput, Typography } from 'sputnik-ui'
import { Card } from 'components'
import { ListItem, ListItemText, Switch } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import {
  getAdminCompanies,
  updateCompanyEmergencyClient,
} from 'store/operations'

const EmergencyCompaniesList = ({
  companies,
  err,
  dispatch,
  handleCompanyChange,
  selected,
  ...props
}) => {
  const { t } = useTranslation('geo')
  const { value: query, bind } = useInput()

  const [debouncedQuery, setDebouncedQuery] = useState()

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(query)
    }, 300)

    return () => {
      clearTimeout(handler)
    }
  }, [query])

  useEffect(() => {
    const params = {
      q: debouncedQuery,
    }
    if (!params.q) {
      delete params.q
    }
    dispatch(getAdminCompanies(params))
  }, [dispatch, debouncedQuery])

  const handleItemClick = (companyUuid) => () => {
    const newSelection = selected === companyUuid ? null : companyUuid
    handleCompanyChange(newSelection)()
  }

  const companyEmergencyClient = (companyUuid) => {
    return companies.find((company) => company.uuid === companyUuid)
  }

  const toggleCompanyAllAccess = (companyUuid) => {
    dispatch(
      updateCompanyEmergencyClient({
        emergency_client: !companyEmergencyClient(companyUuid).emergency_client,
        uuid: companyUuid,
      })
    )
  }

  return (
    <Card title={t('common:companies_plural')} {...props}>
      <Search {...bind} placeholder="search..." />
      {companies ? (
        companies.map((c) => (
          <ListItem key={c.uuid}>
            <Checkbox
              checked={selected === c.uuid}
              onClick={handleItemClick(c.uuid)}
              color="blue"
              style={{
                margin: '0px',
                padding: '0px',
                marginRight: 16,
              }}
            />
            <ListItemText primary={c.name} secondary={c.uuid} />
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography color="textSecondary"> МЧС? </Typography>
              <Switch
                edge="end"
                onChange={() => toggleCompanyAllAccess(c.uuid)}
                checked={companyEmergencyClient(c.uuid)?.emergency_client}
              />
            </div>
          </ListItem>
        ))
      ) : (
        <Loader msg={t('common:companis.loading')} err={err} fluid />
      )}
    </Card>
  )
}

const mapStateToProps = ({ resourcesAdminCompanies }) => ({
  companies: resourcesAdminCompanies.list,
  err: resourcesAdminCompanies.err,
})

export default connect(mapStateToProps)(EmergencyCompaniesList)
